import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { Icon } from 'components/shared/Icon/Icon'

import { useContext } from 'hooks'
import { AlertPropsContext } from '../../context'
import { ICONS, SIZES } from '../../model'
import { ICON_SIZES } from './model'

import styles from './Message.module.scss'

export const Message = () => {
  const { message, size, variant } = useContext(AlertPropsContext)

  return (
    <Box align="center" className={styles.message}>
      <Icon
        className={styles.icon}
        icon={ICONS[variant]}
        size={ICON_SIZES[size]}
      />
      <p
        className={cx(styles.text, styles.size, {
          [styles.medium]: R.equals(size, SIZES.MEDIUM),
          [styles.small]: R.equals(size, SIZES.SMALL),
        })}
      >
        {message}
      </p>
    </Box>
  )
}
